import axios from 'axios';
import router from "../../router";
import get from "bootstrap-vue/esm/utils/get";

const state = {
    productType: null,
    loadingProducts: false,
    wineProducts: [],
    cheeseProducts: [],
    giftProducts: [],
    voucherProducts: [],
    eventProducts: [],
    productFilter: {
        category: 'All Categories',
        variety: 'All Varieties',
        sort: 'Recommended'
    },
    productPageSize: 12,
    productLimit: 12,
    filteredProducts: [],
    product: null,
    filtersPreset: false,
    eventBooked: false
};

const getters = {
    getProductType: () => state.productType,
    getLoadingProducts: () => state.loadingProducts,
    getWineProducts: () => state.wineProducts,
    getCheeseProducts: () => state.cheeseProducts,
    getEventProducts: () => state.eventProducts,
    getGiftProducts: () => state.giftProducts,
    getVoucherProducts: () => state.voucherProducts,
    getCategories: (state, getters) => {
        switch (getters.getProductType) {
            case 'Wine':
                return getters.getWineProducts.Categories
            case 'Cheese':
                return getters.getCheeseProducts.Categories
            case 'Gift':
                return getters.getGiftProducts.Categories
            case 'Voucher':
                return getters.getVoucherProducts.Categories
            case 'Event':
                return getters.getEventProducts.Categories
        }
    },
    getVarieties: (state, getters) => {
        switch (getters.getProductType) {
            case 'Wine':
                return getters.getWineProducts.Varieties
            case 'Cheese':
                return getters.getCheeseProducts.Varieties
            case 'Gift':
                return getters.getGiftProducts.Varieties
            case 'Voucher':
                return getters.getVoucherProducts.Varieties
            case 'Event':
                return getters.getEventProducts.Varieties
        }
    },
    getProducts: (state, getters) => {
        switch (getters.getProductType) {
            case 'Wine':
                return getters.getWineProducts.Products
            case 'Cheese':
                return getters.getCheeseProducts.Products
            case 'Gift':
                return getters.getGiftProducts.Products
            case 'Voucher':
                return getters.getVoucherProducts.Products
            case 'Event':
                return getters.getEventProducts.Products
        }
    },
    getProductFilter: () => state.productFilter,
    getFilteredProducts: () => state.filteredProducts,
    getProductLimit: () => state.productLimit,
    getProduct: () => state.product,
    getEventBooked: () => state.eventBooked
};

const actions = {
    async fetchWine({dispatch, commit}) {
        commit('updateLoadingProducts', true);
        const response = await axios.get('shopstore/fetchWine');
        if (typeof response.data !== 'undefined') {
            let products = response.data.Products;
            if (typeof products !== 'undefined') {
                commit('updateWineProducts', response.data);
                commit('updateFilteredProducts', products);

                dispatch('presetFilters');
            }
            commit('updateLoadingProducts', false);
        }
    },
    async fetchCheese({dispatch, commit}) {
        commit('updateLoadingProducts', true);
        const response = await axios.get('shopstore/fetchCheese');
        if (typeof response.data !== 'undefined') {
            let products = response.data.Products;

            if (typeof products !== 'undefined') {
                commit('updateCheeseProducts', response.data);
                commit('updateFilteredProducts', products);

                dispatch('presetFilters');
            }
            commit('updateLoadingProducts', false);
        }
    },
    async fetchGifts({dispatch, commit}) {
        commit('updateLoadingProducts', true);
        const response = await axios.get('shopstore/fetchGifts');
        if (typeof response.data !== 'undefined') {
            let products = response.data.Products;

            if (typeof products !== 'undefined') {
                commit('updateGiftProducts', response.data);
                commit('updateFilteredProducts', products);

                dispatch('presetFilters');
            }
            commit('updateLoadingProducts', false);
        }
    },
    async fetchVouchers({dispatch, commit}) {
        commit('updateLoadingProducts', true);
        const response = await axios.get('shopstore/fetchVouchers');
        if (typeof response.data !== 'undefined') {
            let products = response.data.Products;

            if (typeof products !== 'undefined') {
                commit('updateVoucherProducts', response.data);
                commit('updateFilteredProducts', products);

                dispatch('presetFilters');
            }
            commit('updateLoadingProducts', false);
        }
    },
    async fetchEvent({dispatch, commit}) {
        commit('updateLoadingProducts', true);
        const response = await axios.get('shopstore/fetchEvents');
        if (typeof response.data !== 'undefined') {
            let products = response.data.Products;

            if (typeof products !== 'undefined') {
                commit('updateEventProducts', response.data);
                commit('updateFilteredProducts', products);

                dispatch('presetFilters');
            }
            commit('updateLoadingProducts', false);
        }
    },
    async fetchProduct({commit}) {
        let productID = $('#product-details').data('product');
        const response = await axios.get('shopstore/fetchProduct/' + productID);
        if (typeof response.data !== 'undefined') {
            commit('updateProduct', response.data);
        }
    },
    async makeRSVP({commit}, data) {
        const response = await axios.post(window.location.origin + '/checkout/eventrsvp', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data.message !== 'undefined') {
            commit('updateEventBooked', true);
        }
    },
    setProductPageSize({commit}, size) {
        commit('updateProductPageSize', size);
        commit('updateProductLimit', size);
    },
    setProductType({dispatch, commit}, type) {
        commit('updateProductType', type);
        commit('updateProductFilter', {category: 'All Categories', variety: 'All Varieties', sort: 'Recommended'});

        switch (type) {
            case 'Wine':
                if (typeof state.wineProducts.Products === 'undefined') {
                    commit('updateFilteredProducts', []);
                    dispatch('fetchWine');
                } else {
                    commit('updateFilteredProducts', state.wineProducts.Products);
                }
                break;
            case 'Cheese':
                if (typeof state.cheeseProducts.Products === 'undefined') {
                    commit('updateFilteredProducts', []);
                    dispatch('fetchCheese');
                } else {
                    commit('updateFilteredProducts', state.cheeseProducts.Products);
                }
                break;
            case 'Gift':
                if (typeof state.giftProducts.Products === 'undefined') {
                    commit('updateFilteredProducts', []);
                    dispatch('fetchGifts');
                } else {
                    commit('updateFilteredProducts', state.giftProducts.Products);
                }
                break;
            case 'Voucher':
                if (typeof state.voucherProducts.Products === 'undefined') {
                    commit('updateFilteredProducts', []);
                    dispatch('fetchVouchers');
                } else {
                    commit('updateFilteredProducts', state.voucherProducts.Products);
                }
                break;
            case 'Event':
                if (typeof state.eventProducts.Products === 'undefined') {
                    commit('updateFilteredProducts', []);
                    dispatch('fetchEvent');
                } else {
                    commit('updateFilteredProducts', state.eventProducts.Products);
                }
                break;
        }
    },
    presetFilters({dispatch, getters, commit}) {
        let preset = state.filtersPreset;
        if (!preset) {
            let queryString = window.location.search,
                urlParams = new URLSearchParams(queryString),
                categoryParam = urlParams.get('category'),
                varietyParam = urlParams.get('variety'),
                products = getters.getProducts,
                categories = getters.getCategories,
                varieties = getters.getVarieties,
                validCategory = 'All Categories',
                validVariety = 'All Varieties';

            if (categoryParam && categories.includes(categoryParam)) {
                validCategory = categoryParam;
            }

            if (varietyParam && varieties.includes(varietyParam)) {
                validVariety = varietyParam;
            }

            commit('updateProductFilter', {category: validCategory, variety: validVariety, sort: 'Recommended'});

            if (products && products.length) {
                dispatch('applyFilter', products);
            }
        }
    },
    applyFilter({dispatch, commit}, products) {
        if (products.length) {
            if (state.productFilter.category !== 'All Categories') {
                products = products.filter(item => {
                    return item.Categories.includes(state.productFilter.category);
                });
            }

            if (state.productFilter.variety !== 'All Varieties') {
                products = products.filter(item => {
                    return item.Varieties.includes(state.productFilter.variety);
                });
            }
        }

        dispatch('applySort', products);
    },
    applySort({commit}, products) {
        if (products.length > 0) {
            switch (state.productFilter.sort) {
                case 'Recommended':
                    products.sort((a, b) => (a.Sort - b.Sort));
                    break;
                case 'Price (low to high)':
                    products.sort((a, b) => (a.LocalisedPrice - b.LocalisedPrice));
                    break;
                case 'Price (high to low)':
                    products.sort((a, b) => (b.LocalisedPrice - a.LocalisedPrice));
                    break;
                case 'Alphabetical':
                    products.sort((a, b) => a.Title.localeCompare(b.Title));
                    break;
            }
        }

        commit('updateFilteredProducts', products);
    },
    loadMore({commit}) {
        let limit = state.productLimit,
            pageSize = state.productPageSize,
            nextLimit = parseFloat(limit) + parseFloat(pageSize);
        commit('updateProductLimit', nextLimit);
    },
    async updateWishList({commit}, link) {
        const response = await axios.get(link);
        if (typeof response.data !== 'undefined') {

        }
    },
};

const mutations = {
    updateProductType: (state, value) => (state.productType = value),
    updateLoadingProducts: (state, value) => (state.loadingProducts = value),
    updateWineProducts: (state, value) => (state.wineProducts = value),
    updateCheeseProducts: (state, value) => (state.cheeseProducts = value),
    updateEventProducts: (state, value) => (state.eventProducts = value),
    updateGiftProducts: (state, value) => (state.giftProducts = value),
    updateVoucherProducts: (state, value) => (state.voucherProducts = value),
    updateProductFilter: (state, value) => (state.productFilter = value),
    updateFilteredProducts: (state, value) => (state.filteredProducts = value),
    updateProductLimit: (state, value) => (state.productLimit = value),
    updateProductPageSize: (state, value) => (state.productPageSize = value),
    updateProduct: (state, value) => (state.product = value),
    updateFiltersPreset: (state, value) => (state.filtersPreset = value),
    updateEventBooked: (state, value) => (state.eventBooked = value)
};

export default {
    state,
    getters,
    actions,
    mutations
};
